// import zhCN from './zh-CN.js'
import enUS from './en-US.js'
import arAR from './ar-AR.js'
// import esES from './es-ES.js'
export default {
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE,
  messages: {
    // 'zh-CN': zhCN,
    'en-US': enUS,
    'ar-AR': arAR
    // 'es-ES': esES
  }
}
